<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-table #pt [value]="ownerLeadProfiles" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ownerLeadProfileId"
  selectionMode="single" [(selection)]="ownerLeadProfile" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="showPagination" [rows]="25" [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Owner Lead Profiles</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New Owner Lead Profile +</button>
        <app-import-export (dataAndTagsSelected)="dataAndTagSelected($event)" [tagsourceForInput]="10" [dataRetrived]="ownerLeadProfiles"
        (exportDataSelected)="exportSelected($event)" [sampleFileLink]="sampleLink" [columns]="columns"></app-import-export>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [ngStyle]="{'width': 'auto'}">
          @if (col.sorting) {
            <span [pSortableColumn]="col.field">
              {{ col.header }}
              @if (!reservationId) {
                <p-sortIcon [field]="col.field"></p-sortIcon>
              }
            </span>
          } @else {
            {{ col.header }}
          }
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}">Tags</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'assignToSalesAgnt1', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'assignToSalesAgnt2', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'leadSource', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'leadType', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown [options]="leadStatuses" [dropdownIcon]="'fa fa-caret-down'" optionLabel="name" optionValue="value" [showClear]="true"
            placeholder="Status" [style]="{'width':'100%'}" [appendTo]="'body'" [panelStyle]="{'z-index':'11060'}"
          (onChange)="pt.filter($event.value, 'leadStatus', 'in')"></p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'title', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="date" (input)="pt.filter($event.target.value, 'createDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="date" (input)="pt.filter($event.target.value, 'lastUpdate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'realtorProfile.lastName', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><app-tag-join-filter-select [tagSource]="10" (getFilteredTags)="getFilteredTags($event)"></app-tag-join-filter-select></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-ownerLeadProfile>
    <tr [pSelectableRow]="ownerLeadProfile">
      <td>{{ownerLeadProfile.firstName}}</td>
      <td>{{ownerLeadProfile.lastName}}</td>
      <td>{{ownerLeadProfile?.assignToSalesAgnt1?.firstName}} {{ownerLeadProfile?.assignToSalesAgnt1?.lastName}}</td>
      <td>{{ownerLeadProfile?.assignToSalesAgnt2?.firstName}} {{ownerLeadProfile?.assignToSalesAgnt2?.lastName}}</td>
      <td>{{ownerLeadProfile.leadSource}}</td>
      <td>{{ownerLeadProfile.leadType}}</td>
      <td>{{getStatusName(ownerLeadProfile)}}</td>
      <td>{{ownerLeadProfile.title}}</td>
      <td>{{ownerLeadProfile.createDate | date}}</td>
      <td>{{ownerLeadProfile.lastUpdate | date}}</td>
      <td>{{getRealtorLastName(ownerLeadProfile)}}</td>
      <!-- <td><p *ngFor="let tag of ownerLeadProfile.tagJoinAPIS">{{tag.name}}</p></td> -->
      <app-tag-join-list-select [tagSource]="10" [tagSourceId]="ownerLeadProfile.ownerLeadProfileId" tagType="4"></app-tag-join-list-select>
      <!-- <td>{{getStatusName(ownerLeadProfile)}}</td> -->
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(ownerLeadProfile)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>
